import axios from 'axios';

import { server } from 'common/config';
import { dispatch } from 'store';
import { logout } from 'store/slices/account';


function getCookie(name: any) {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match) {
        return match[2];
    }
    return null;
}

// service 1
const axiosServicesV1 = axios.create({
    baseURL: `${server.UAT_PEGA_API}/api/v1`,
    withCredentials: true
});

axiosServicesV1.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            try {
                const logoutChannel = new BroadcastChannel('logout');
                logoutChannel.postMessage('logout');
                localStorage.removeItem('imda_expires_in');
                localStorage.removeItem('imda_started');
                localStorage.removeItem('id');
                localStorage.removeItem('imda_sp_expires');
                localStorage.removeItem('uen');
                // document.cookie = 'irisToken=; Path=/;';

                dispatch(logout());
            } catch (error) {
                localStorage.removeItem('imda_expires_in');
                localStorage.removeItem('imda_started');
                localStorage.removeItem('id');
                localStorage.removeItem('imda_sp_expires');
                localStorage.removeItem('uen');
                // document.cookie = 'irisToken=; Path=/;';

                dispatch(logout());
            }
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);

axiosServicesV1.interceptors.request.use((config) => {
    if (config.headers) {
        const id = window.localStorage.getItem('id');
        const uen = window.localStorage.getItem('uen');
        document.cookie = 'iris=true; Path=/;';

        // irisToken is now httpOnly and sent automatically by browser
        // Backend will read it from cookie header
        config.headers.IDNo = `${id}`;
        config.headers.UEN = `${uen}`;
    }
    return config;
});

// service 2
const axiosServicesV2 = axios.create({
    baseURL: `${server.UAT_PEGA_API}/api/application/v2`,
    withCredentials: true
});

axiosServicesV2.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            try {
                const logoutChannel = new BroadcastChannel('logout');
                logoutChannel.postMessage('logout');
                localStorage.removeItem('imda_expires_in');
                localStorage.removeItem('imda_started');
                localStorage.removeItem('id');
                localStorage.removeItem('imda_sp_expires');
                localStorage.removeItem('uen');
                // document.cookie = 'irisToken=; Path=/;';
                dispatch(logout());
            } catch (error) {
                localStorage.removeItem('imda_expires_in');
                localStorage.removeItem('imda_started');
                localStorage.removeItem('id');
                localStorage.removeItem('imda_sp_expires');
                localStorage.removeItem('uen');
                // document.cookie = 'irisToken=; Path=/;';
                dispatch(logout());
            }
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);

axiosServicesV2.interceptors.request.use((config) => {
    if (config.headers) {
        const id = window.localStorage.getItem('id');
        const uen = window.localStorage.getItem('uen');
        document.cookie = 'iris=true; Path=/;';

        // irisToken is now httpOnly and sent automatically by browser
        config.headers.IDNo = `${id}`;
        config.headers.UEN = `${uen}`;
    }
    return config;
});

// service 3
const axiosServicesV3 = axios.create({
    baseURL: server.UAT_PEGA_API,
    withCredentials: true
});

axiosServicesV3.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            try {
                const logoutChannel = new BroadcastChannel('logout');
                logoutChannel.postMessage('logout');
                localStorage.removeItem('imda_expires_in');
                localStorage.removeItem('imda_started');
                localStorage.removeItem('id');
                localStorage.removeItem('imda_sp_expires');
                localStorage.removeItem('uen');
                // document.cookie = 'irisToken=; Path=/;';
                dispatch(logout());
            } catch (error) {
                localStorage.removeItem('imda_expires_in');
                localStorage.removeItem('imda_started');
                localStorage.removeItem('id');
                localStorage.removeItem('imda_sp_expires');
                localStorage.removeItem('uen');
                // document.cookie = 'irisToken=; Path=/;';
                dispatch(logout());
            }
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);

axiosServicesV3.interceptors.request.use((config) => {
    if (config.headers) {
        const id = window.localStorage.getItem('id');
        const uen = window.localStorage.getItem('uen');
        document.cookie = 'iris=true; Path=/;';

        // irisToken is now httpOnly and sent automatically by browser
        config.headers.IDNo = `${id}`;
        // Preserve UEN supplied by validateUEN().
        // Use stored value only when no request UEN exists.
        if (!config.headers.has('uen') && uen) {
            config.headers.set('uen', uen);
        }
    }
    return config;
});

// service 4 - Main domain service
const axiosServicesMain = axios.create({
    baseURL: server.UAT_MAIN_DOMAIN,
    withCredentials: true  // Your domain - safe to send credentials
});

// Third-party services - DO NOT send credentials (security risk!)
// withCredentials is FALSE by default - never send cookies to external domains
const axiosMyInfo = axios.create({
    baseURL: 'https://80stixcqtl.execute-api.ap-southeast-1.amazonaws.com/dev'
});

const axiosServicesMyinfoEdhDev = axios.create({
    baseURL: 'https://dokyoec796.execute-api.ap-southeast-1.amazonaws.com/Dev',
    headers: {
        'x-api-key': 'Kk9qcUb0TT6fXY9Zi2dww4mq9QxSess17MeZC1Pg'
    }
});
export { axiosServicesV1, axiosServicesV2, axiosServicesV3, axiosServicesMain, axiosMyInfo, axiosServicesMyinfoEdhDev };
